module.exports = __webpack_public_path__ + "static/img/LFD_store.5cc82c68.png";